module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-50.cc59fb9c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-50.png
// module id = 3361
// module chunks = 11